import Cookies from "js-cookie";

export default function cookieHandler(cid) {
  const blockEmailValues = ["googleAds", "bingAds", "emailMarketing", "awin"];

  const cookieResponse = cid === "" ? "directAccess" : cid || "directAccess";

  // console.log("cookieHandler called with:", cookieResponse);

  if (
    blockEmailValues.includes(cookieResponse) ||
    cookieResponse === "directAccess"
  ) {
    Cookies.remove("blockEmail");
    Cookies.set("customCid", cookieResponse, { expires: 1 });
  } else {
    Cookies.remove("customCid");
    Cookies.set("blockEmail", cookieResponse, { expires: 1 });
  }

  return cookieResponse;
}
